import AdvancedSearch from './AdvancedSearch';
import SuggestionsTable from './SugestionsTabla';
import { useAdvancedSearch } from './hooks/useAdvancedSearch';

const AdvancedSearchContainer = () => {
  const {
    searchType,
    setSearchType,
    selectedFilter,
    setSelectedFilter,
    text,
    selectedItems,
    showTextarea,
    pendingAutoSearch,
    autoSearchTriggeredFromEnrichment,
    suggestionsData,
    loading,
    handleQueryChange,
    handleSearchClick,
    handleBackClick,
    handleInputValidation,
    handleSearchSelectedItems,
    handleSelectAll,
    handleClearAll,
    clearInputText,
    showExamples,
    handleCheckboxSelection,
  } = useAdvancedSearch();

  const renderSuggestions = () => {
    return (
      <SuggestionsTable
        suggestionsData={suggestionsData}
        selectedItems={selectedItems}
        handleCheckboxSelection={handleCheckboxSelection}
        searchType={searchType}
        selectedFilter={selectedFilter}
      />
    );
  };

  return (
    <AdvancedSearch
      searchType={searchType}
      setSearchType={setSearchType}
      selectedFilter={selectedFilter}
      setSelectedFilter={setSelectedFilter}
      text={text}
      handleQueryChange={handleQueryChange}
      handleSearchClick={handleSearchClick}
      clearInputText={clearInputText}
      showExamples={showExamples}
      renderSuggestions={renderSuggestions}
      loading={loading}
      suggestionsData={suggestionsData}
      handleBackClick={handleBackClick}
      handleSearchSelectedItems={handleSearchSelectedItems}
      handleSelectAll={handleSelectAll}
      handleClearAll={handleClearAll}
      showTextarea={showTextarea}
      pendingAutoSearch={pendingAutoSearch}
      autoSearchTriggeredFromEnrichment={autoSearchTriggeredFromEnrichment}
      validateInput={handleInputValidation}
      selectedItems={selectedItems}
    />
  );
};

export default AdvancedSearchContainer;
